var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpositionArrow(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24.4334px",
    height: "39.7195px",
    viewBox: "0 0 24.4334 39.7195",
    style: {
      enableBackground: "new 0 0 24.4334 39.7195"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#1F2346;stroke-width:1.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.603,1.2634L1.1562,17.1539c-0.3594,0.5467,0.0327,1.2737,0.687,1.2737h2.88 c0.4235,0,0.7777,0.3217,0.8183,0.7432l1.0728,4.4577c0.0407,0.4215,0.3949,0.7432,0.8183,0.7432h9.7153 c0.4235,0,0.7777-0.3217,0.8183-0.7432l1.0722-4.4576c0.0406-0.4215,0.3948-0.7432,0.8183-0.7432h2.8799 c0.6542,0,1.0464-0.7271,0.687-1.2737L12.9769,1.2634C12.6521,0.7694,11.9277,0.7694,11.603,1.2634z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.244,30.6006l0.551-2.3274c0.0466-0.483-0.3331-0.901-0.8183-0.901h-7.372 c-0.4853,0-0.8649,0.4181-0.8183,0.9011l0.5513,2.3274c0.0407,0.4215,0.3949,0.7432,0.8183,0.7432h6.2697 C15.8491,31.3439,16.2033,31.0222,16.244,30.6006z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1799,38.016l0.4027-2.3573c0.034-0.4892-0.2434-0.9126-0.5981-0.9126H9.5967 c-0.3546,0-0.6321,0.4235-0.5981,0.9127l0.4029,2.3573c0.0297,0.4269,0.2886,0.7527,0.5981,0.7527h4.5822 C14.8913,38.7688,15.1502,38.443,15.1799,38.016z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpositionArrow);
export default __webpack_public_path__ + "static/media/exposition-arrow.8d46b583fcc4d651583f0a8283358532.svg";
export { ForwardRef as ReactComponent };